export default {"src":"/login-app/[GIT_HASH]/_next/static/media/partition_missing.f9c386fa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};